import router from '@/site/router'
import store from '@/site/store'

router.beforeEach((to, from, next) => {
	let showFooter = to.meta && to.meta.showFooter === false ? false : true
	store.set('layout/showFooter', showFooter)
	next()
})
